import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dictionary } from '@feedyou/utils'
import { ObjectSsmlValidationResult } from '../../features/ssml/types'

export type ValidatedEntityId = string

export type FullValidationResult = Dictionary<ValidatedEntityId, ObjectSsmlValidationResult>

export type SsmlSlice = {
  shouldHideSsml: boolean
  validationResults: {
    // Those two caches cannot be combined, because they include different sets of entities
    // live validation includes all MOUNTED tree entities, full validation includes all USER ACCESSIBLE entities
    live: FullValidationResult // live validation is a cache for real-time error display in bot tree
    full: FullValidationResult // full validation validates whole bot at once,
  }
}

export const initialState: SsmlSlice = {
  shouldHideSsml: false,
  validationResults: {
    live: {},
    full: {}
  }
}

export const { reducer, actions } = createSlice({
  name: 'ssml',
  initialState,
  reducers: {
    setShouldHideSsml: (state, action: PayloadAction<boolean>) => {
      state.shouldHideSsml = action.payload
    },

    updateLiveValidationResultForEntity: (
      state,
      action: PayloadAction<{
        id: ValidatedEntityId
        result?: ObjectSsmlValidationResult
      }>
    ) => {
      const { id, result } = action.payload

      if (!state.validationResults.live[id]) {
        state.validationResults.live[id] = {}
      }

      state.validationResults.live[id] = {
        ...state.validationResults.live[id],
        ...result
      }
    },

    setFullValidationResult: (state, action: PayloadAction<FullValidationResult>) => {
      state.validationResults.full = action.payload
    },
    clearSsmlValidationResults: state => {
      state.validationResults.full = {}
    }
  }
})
